import { Chip, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

export const AreaStatusChip: Cell<{ isInside: boolean }> = ({ isInside }) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <CellFrame>
      <Chip
        color={isInside ? 'primary' : 'error'}
        label={
          <Typography variant="subtitle2" color="white">
            {isInside ? t('areaExist') : t('areaNotExist')}
          </Typography>
        }
        sx={{ mb: 2 }}
      />
    </CellFrame>
  )
}
